import { axiosClient } from '../config/axiosClient';

// Endpoint de inmuebles
const API_INMUEBLES = '/catalogo';

// Endpoint de localidades
const API_LOCALIDADES = '/city';

// Base URL del CDN para imágenes y PDFs
const CDN_BASE = '/cdn/';

// Endpoint para enviar consultas de usuarios
const API_CONSULTA = '/consultas';

// Cache en memoria para no pegarle al backend 100 veces
let localidadesCache: Record<number, string> = {};

export const getInmuebleById = async (id: string | number) => {
  try {
    const response = await axiosClient.get(`${API_INMUEBLES}/${id}`);
    return response.data;
  } catch (error) {
    console.error(`Error en getInmuebleById para el ID ${id}:`, error);
    throw error;
  }
};

export function buildAssetUrl(clave?: string) {
  if (!clave) return '';

  const base = process.env.REACT_APP_FEEDBACK_API_URL || '';

  return `${base}${CDN_BASE}${clave}`;
}

export async function getLocalidades(): Promise<Record<number, string>> {
  if (Object.keys(localidadesCache).length > 0) {
    return localidadesCache;
  }

  const res = await axiosClient.get(API_LOCALIDADES);

  const lista = Array.isArray(res.data)
    ? res.data
    : Array.isArray(res.data.data)
    ? res.data.data
    : Array.isArray(res.data.result)
    ? res.data.result
    : [];

  const map: Record<number, string> = {};

  lista.forEach((l: any) => {
    map[l.id_localidad] = l.desc_localidad;
  });

  localidadesCache = map;

  return map;
}

export async function getInmuebles(): Promise<any[]> {
  const res = await axiosClient.get(API_INMUEBLES);

  return Array.isArray(res.data)
    ? res.data
    : Array.isArray(res.data.data)
    ? res.data.data
    : [];
}

export async function enviarConsulta(data: any) {
  try {
    const res = await axiosClient.post(API_CONSULTA, data);
    return res.data;
  } catch (error) {
    console.error('Error enviando consulta:', error);
    throw error;
  }
}